export default __webpack_public_path__ + "static/media/fedora.965d22b9.svg";